import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { PageSection } from '../PageSection';
import { PRODUCT_NAME } from '../../data/salesContent';
export function SolutionSection() {
  return <PageSection labelledBy="solution-title" className="bg-slate-950" data-id="element-172" data-mp="15znsliuz7whm">
      <SectionHeading id="solution-title" title="Todo lo que necesitás. Un solo sistema." data-id="element-173" data-mp="15ycjd3irhwj4" />
      <div className="mx-auto mt-6 max-w-xl text-center" data-id="element-174" data-mp="19zg3413xkcpm">
        <p className="font-display text-lg font-extrabold uppercase text-cyan-400 md:text-xl" data-id="element-175" data-mp="dct7cjqc4t33">4 volúmenes + 5 bonos prácticos</p>
        <p className="mt-1 font-display text-base font-bold uppercase tracking-wide text-zinc-300" data-id="element-176" data-mp="i8ibz1h7p069">{PRODUCT_NAME}</p>
        <p className="mt-5 text-base leading-relaxed text-zinc-300 md:text-[17px]" data-id="element-177" data-mp="r2wo4v6g3ul5">
          Reúne conocimientos básicos del vehículo, mantenimiento preventivo, detección de señales, preparación para emergencias,
          planificación, tablero, viajes, historial y herramientas para el taller.
        </p>
        <p className="mt-4 text-base font-semibold leading-relaxed text-white md:text-[17px]" data-id="element-178" data-mp="32koch1lakmro">
          Todo presentado de manera visual y comprensible para personas que <span className="text-cyan-400" data-id="element-179" data-mp="2xmmt0fjyelfo">NO</span> necesitan
          saber mecánica previamente.
        </p>
      </div>
    </PageSection>;
}